import type { ProductCarouselItem } from '@noths/polaris-design-system-candidate-components';
import type { CurrencyCode } from '@noths/polaris-dev-ts-types';

import type { CatalogServiceProductData } from 'src/services/catalog/types';
import { transformProductModelToProduct } from 'src/utils/catalogProductToProduct';

/**
 * One carousel item is one card's props: the product itself plus the flags that
 * are presentation rather than properties of the product.
 */
export const transformProductModelToProductCarouselItem = (
  product: CatalogServiceProductData,
  {
    currency,
    priority,
    promoteAsSale,
  }: { currency: CurrencyCode; priority: boolean; promoteAsSale: boolean },
): ProductCarouselItem => ({
  isNew: product.isNew,
  priority,
  product: transformProductModelToProduct(product, { currency }),
  /* From the site-wide Contentstack switch, not `product.onSale`. No discount in the
     catalogue distinguishes a sale from an offer, so presenting one as either is a
     decision about the whole site rather than about this product. */
  promoteAsSale,
});
